import { useAuthenticator } from '@aws-amplify/ui-react';

/** Whether the user is signed in (via Cognito / Amplify). */
export function useIsAuthenticated(): boolean {
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);
  return authStatus === 'authenticated';
}
